export default __webpack_public_path__ + "static/media/O-048.7f104e44.png";